import { create } from 'zustand';

/**
 * The upgrade prompt a locked control opens (web_app_design.md §2). A lock stays clickable: a
 * greyed row that does nothing reads as broken, while a click that says what the lock is, which
 * plan lifts it and whether a free trial applies is the upgrade ask at the moment it is wanted.
 * One dialog, mounted once by the shell, so every lock tells the same story.
 */
export interface UpgradeAsk {
  /** The plan that lifts the lock. */
  plan: 'pro' | 'elite';
  /** What was clicked, as the title says it: "XAU/USD", "The 1d timeframe". */
  subject: string;
}

interface UpgradePromptState {
  ask: UpgradeAsk | null;
  show: (ask: UpgradeAsk) => void;
  close: () => void;
}

export const upgradePrompt = create<UpgradePromptState>((set) => ({
  ask: null,
  show: (ask) => set({ ask }),
  close: () => set({ ask: null }),
}));

/** The plan that lifts an instrument lock: Elite for US stocks and ETFs (the asset class it sells), Pro otherwise. */
export function planForInstrument(i: { asset_type: string }): UpgradeAsk['plan'] {
  return i.asset_type === 'equity' ? 'elite' : 'pro';
}
